<template>
    <transition name="modal">
        <div class="modal__mask modalRepresentantesPF" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">
                        <a
                            @click.stop.prevent="closeModal"
                            class="close__modal"
                        >
                            x
                        </a>
                        <div class="inner__modal">
                            <div style="display: inline-flex">
                                <div style="width: 20%">
                                    <img style="width: 50px; height: 50px; margin-top: 0px;" src="@/assets/addRepresentante.png" />
                                </div>
                                 <div style="width: 80%">
                                <h2 style="margin-left: 5px;
                                margin-top: 10px;
                                font-size: 16px;">Adicionar representante</h2>
                                 </div>
                            </div>

                            <form
                                action=""
                                class="form__class"
                                @submit.stop.prevent="createRepresentante"
                            >

                                
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            Selecione tipo
                                        </label>

                                        <select
                                            class="field"
                                            v-model="representante.Tipo"  
                                            :disabled="representante.Guid != ''"
                                        >
                                                               
                                         <option value="">Selecione</option>
                                            <option value="Representante">Representante</option>
                                            <option value="Procurador">
                                                Procurador
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form__controls">

                                    <InputNome 
                                        v-model="representante.Nome"
                                        label="Nome"
                                        :required="true"
                                        :erroDesc="erroName"
                                    />

                                    </div>
                                </div>

                                 <div class="row">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            Documento
                                        </label>

                                        <input
                                            type="text"
                                            class="field"
                                            autocomplete="off"
                                            @click.stop.prevent="clear"  
                                            v-model="representante.Documento"                                         
                                        />                                        
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            CPF
                                        </label>

                                        <input
                                            type="text"
                                            class="field"
                                            autocomplete="off"
                                            @click.stop.prevent="clear"  
                                            v-model="representante.Cpf"    
                                            v-mask="'###.###.###-##'"                                     
                                        />                                        
                                    </div>
                                </div>

                                
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            E-mail*
                                        </label>

                                        <input
                                            type="text"
                                            class="field"
                                            autocomplete="off"
                                            @click.stop.prevent="clear"  
                                            v-model="representante.Email"                                        
                                        />                                        
                                    </div>
                                </div>

                                                                                        <div class="row">
                    <div class="form__controls" style="width: 100%">
                      <label class="label" for="nome">Será emissor de ordem?*</label>
                      <div class="radio">
                                            <input
                                                type="radio"
                                                id="false"
                                                name="emissorOrdem"
                                                class="field__radio"
                                                value="false"
                                                @change="salvarAlteracoesLocalmente"
                                                v-model="representante.EmissorOrdem"
                                            />
                                            <label
                                                for="Nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                                type="radio"
                                                id="true"
                                                value="true"
                                                name="emissorOrdem"
                                                class="field__radio field__radio_second"
                                                @change="salvarAlteracoesLocalmente"
                                                v-model="representante.EmissorOrdem"
                                            />
                                            <label
                                                for="Sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>

                                        </div>
                    </div>

                </div>

                                                        <div class="row">
                    <div class="form__controls" style="width: 100%">
                      <label class="label" for="nome">É considerado US PERSON?*</label>
                      <div class="radio">
                                            <input
                                                type="radio"
                                                id="false"
                                                name="UsPerson"
                                                class="field__radio"
                                                value="false"
                                                @change="salvarAlteracoesLocalmente"
                                                v-model="representante.UsPerson"
                                            />
                                            <label
                                                for="Nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                                type="radio"
                                                id="true"
                                                value="true"
                                                name="UsPerson"
                                                class="field__radio field__radio_second"
                                                @change="salvarAlteracoesLocalmente"
                                                v-model="representante.UsPerson"
                                            />
                                            <label
                                                for="Sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>

                                        </div>
                    </div>

                </div>

                                                                       <div class="row">
                    <div class="form__controls" style="width: 100%">
                      <label class="label" for="nome">É uma Pessoa Exposta Politicamente?*</label>
                      <div class="radio">
                                            <input
                                                type="radio"
                                                id="false"
                                                name="PoliticamenteExposta"
                                                class="field__radio"
                                                value="false"
                                                @change="salvarAlteracoesLocalmente"
                                                v-model="representante.PoliticamenteExposta"
                                            />
                                            <label
                                                for="Nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                                type="radio"
                                                id="true"
                                                value="true"
                                                name="PoliticamenteExposta"
                                                class="field__radio field__radio_second"
                                                @change="salvarAlteracoesLocalmente"
                                                v-model="representante.PoliticamenteExposta"
                                            />
                                            <label
                                                for="Sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>

                                        </div>
                    </div>

                </div>

                                <div class="buttonsAcoes">         
                                                                        <button                                    
                                            class="btnDefault"
                                            type="button"
                                            @click="closeModal"
                                        >
                                            Cancelar
                                        </button>                                 
                                    <button                                    
                                            class="btnBlue"
                                            type="button"
                                            @click="salvarRepresentante"
                                        >
                                            Adicionar
                                        </button>                              
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';

export default {
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_PJ_ADD_PESSOA",
            editarRepresentante: 'GET_MODAL_PJ_EDITAR_PESSOA',
            user: 'auth/user',
        }),
    },
    data() {
    return {
        disableBtn: false,
        erroName: '',
        representante: {
            Guid: '',
            Nome: '',
            Email: '',
            Cpf: '',
            Documento: '',
            UsPerson: false,
            PoliticamenteExposta: false,
            EmissorOrdem: false,
            Tipo: ''
            }
        }
    },
    watch: {
        editarRepresentante(){
            this.representante = this.editarRepresentante;
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", false);
            this.$store.commit("SET_MODAL_PJ_EDITAR_PESSOA", null);
            
        },
        limparObj(){
            this.representante = {
                Guid: '', // valor padrão
                Nome: '', // valor padrão
                Email: '', // valor padrão
                Documento: '',
                Cpf: '', // valor padrão
                EmissorOrdem: false,
                UsPerson: false, // valor padrão
                PoliticamenteExposta: false, // valor padrão
                Tipo: '' // valor padrão
            };
        },
        async salvarRepresentante(){
             this.disableBtn = true;
              

                await api
                    .post('/PessoaFisica/representante', this.representante)
                    .then((retorno) => {
                          this.disableBtn = false;
                        if(retorno.status == 200)
                        {

                          this.$swal({
                              icon: 'success',
                              title: this.representante.Guid == '' ? 'Inclusão realizada com sucesso!' : 'Alteração realizada com sucesso!',
                              text: 'Dados informados foram salvos com sucesso.',
                          });
                          this.limparObj();
                          this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", false);

                          this.$store.dispatch('FETCH_PF_LISTA_REPRESENTANTES');

                        }
                    })
                    .catch((error) => {
                        this.disableBtn = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos informado para representante',
                            text: `${error.response.data.data[0]}`,
                        });
                    });

        }
    },
};
</script>

<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.modalRepresentantesPF .modal__wrapper .modal__container.reset {
        width: 400px !important;
        height: 636px !important;
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>
